module.exports = __webpack_public_path__ + "img/DNARepair-PRCA_10X_ACC.a6f7e125.png";